export default "__VITE_ASSET__62222e20__"